<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script setup>
import { IonApp, IonRouterOutlet, toastController, alertController } from '@ionic/vue';
import { notificationsOutline } from 'ionicons/icons';
import { onMounted } from "vue";
import { messaging, getToken, onMessage } from "./firebase";
import VueCookies from 'vue-cookies'

// Detectar iOS
const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

onMounted(async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    console.warn("⚠️ Este navegador no soporta Firebase Messaging");
    return;
  }

  try {
    // Registrar Service Worker
    const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log("SW registrado ✅", swRegistration);

    // Revisar token guardado
    const tokenGuardado = VueCookies.get('fcm_token');
    if (!tokenGuardado) {
      if (isIos) {
        await pedirPermisoIos();
      } else {
        await pedirPermisoAndroid();
      }
    } else {
      console.log("Token ya existente:", tokenGuardado);
    }

    // Escuchar notificaciones en foreground
    onMessage(messaging, async (payload) => {
      console.log("Notificación en foreground:", payload);

      const title = payload.notification?.title || payload.data?.title || "Notificación";
      const body = payload.notification?.body || payload.data?.body || "";

      const toast = await toastController.create({
        message: body,
        duration: 30000,
        position: 'top',
        mode: 'ios',
        icon: notificationsOutline,
      });

      await toast.present();
    });

  } catch (err) {
    console.error("Error Firebase Messaging:", err);
  }
});

// Solicitar permisos en iOS con alerta
const pedirPermisoIos = async () => {
  const alert = await alertController.create({
    header: 'Notificaciones',
    message: 'Para recibir notificaciones, pulsa Activar y acepta los permisos.',
    buttons: [
      { text: 'Cancelar', role: 'cancel' },
      {
        text: 'Activar',
        handler: async () => {
          const permiso = await Notification.requestPermission();
          if (permiso === 'granted') {
            await obtenerTokenFCM();
          } else {
            console.warn("Permiso de notificaciones iOS denegado");
          }
        }
      }
    ]
  });
  await alert.present();
};

// Solicitar permisos en Android
const pedirPermisoAndroid = async () => {
  const permiso = await Notification.requestPermission();
  if (permiso === 'granted') {
    await obtenerTokenFCM();
  } else {
    console.warn("Permiso de notificaciones Android denegado");
  }
};

// Obtener token FCM y guardarlo
const obtenerTokenFCM = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: "BAfvnl_ifL32ITxgrdOBOW62rczls3b1YVTQ1ss2Uh5tqdT_8vjucP46AgJXjQ6doTwfLaVLNRNgPpsXgSTzR5A"
    });
    if (token) {
      console.log('Token FCM:', token);
      VueCookies.set('fcm_token', token, '1y'); // Guardar token 1 año
      // TODO: Enviar token a backend si es necesario
    }
  } catch (err) {
    console.error("Error obteniendo token FCM:", err);
  }
};
</script>
